"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactWebcam = _interopRequireDefault(require("react-webcam"));
var _WebcamPreview = require("./WebcamPreview.styles");
var _theme = require("../utils/theme");
var _Button = require("../Button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var videoConstraints = {
  facingMode: 'user'
};
var WebcamPreview = function WebcamPreview(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    children = _ref.children,
    onCapture = _ref.onCapture,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 500 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 500 : _ref$height;
  var webcamRef = (0, _react.useRef)(null);
  var capture = (0, _react.useCallback)(function () {
    var imageSrc = webcamRef.current.getScreenshot().split(',').pop();
    onCapture(imageSrc);
  }, [webcamRef]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_WebcamPreview.WebcamContainer, null, /*#__PURE__*/_react["default"].createElement(_reactWebcam["default"], {
    audio: false,
    height: height,
    ref: webcamRef,
    screenshotFormat: "image/jpeg",
    width: width,
    style: {
      borderRadius: '10px'
    },
    videoConstraints: _objectSpread({
      width: width,
      height: height
    }, videoConstraints)
  }), /*#__PURE__*/_react["default"].createElement(_WebcamPreview.TakePictureButton, null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    dense: true,
    icon: "camera",
    themeColor: _theme.defaultTheme.color.success,
    onClick: capture
  }, "Take Picture"))));
};
var _default = exports["default"] = WebcamPreview;